import { FILTER, MENTION_KIND } from "@/constants";
import CheckboxSelect from "@/containers/Filters/CheckboxSelect";
import FilterCountIndicator from "@/containers/Filters/FilterCountIndicator";
import useFilterCount from "@/containers/Filters/hooks/useFilterCount";
import { FilterOption } from "@/types/FilterOptions";
import { Accordion } from "@components/Accordion";

import useOptionLabel from "../../hooks/useOptionLabel";
import { useLingui } from "@lingui/react/macro";

const MentionKind: React.FunctionComponent = () => {
  const { t } = useLingui();
  const OPTIONS: FilterOption[] = [
    [MENTION_KIND.AUDIO, t`Endast träffar i tal`],
    [MENTION_KIND.TEXT, t`Endast träffar i text (inkluderar metadata)`],
  ];

  const preview = useOptionLabel(FILTER.MENTION_KIND, OPTIONS);
  const count = useFilterCount(FILTER.MENTION_KIND);

  return (
    <Accordion
      value="mention-kind"
      data-testid="filter-bar--mention-kind"
      title={t`Typ av omnämnande`}
      indicator={<FilterCountIndicator count={count} />}
      preview={preview}
    >
      <CheckboxSelect name={FILTER.MENTION_KIND} options={OPTIONS} />
    </Accordion>
  );
};

export default MentionKind;
